import { DateTime } from 'luxon';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { slugFromCompanyName } from '@/lib/account/slug';

export const accountInfosUpdate = ({ companyName, companySize, companyImage }) => {
  const now = DateTime.local().toISO();
  const update = {
    companyName,
    numberOfEmployees: companySize,
    activeSlug: { slug: slugFromCompanyName(companyName) },
    accountSettings: {
      accountInfosCompleted: now,
      moduleSelectionCompleted: now,
      usesUpdates: true,
      usesGoals: true,
    },
  };

  if (!isNullOrUndefined(companyImage)) {
    update.companyImage = { blob: companyImage.fileId, getURL: companyImage.getURL };
  }

  return update;
};
